import * as React from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { VFFieldProps } from '../types';
import { FormItem } from './FormItem';
import classNames from 'classnames';
import {
  defaultMultiSelectGetLabel,
  MultiSelectSearch,
} from '../../multiselect/MultiSelectSearch';
import * as Classes from '../../common/classes';
import { Text } from '../../typography/Text';
import { FilterInputButton } from '../../button/FilterInputButton';
import { DATA_FORM_INPUT } from '../../common/data';
import { ElementOf, tuple } from '../../common/props';

export const MultiSelectModes = tuple('input', 'inline');
export type MultiSelectMode = ElementOf<typeof MultiSelectModes>;

export type MultiSelectProps = Omit<
  VFFieldProps<React.ComponentProps<typeof MultiSelectSearch>>,
  'value'
> & {
  /**
   * Jak se má komponenta chovat - jako klasický input s popupem nebo jako inline prvek - tedy obsah popup. Výchozí hodnota je 'input'.
   */
  mode?: MultiSelectMode;
};
export const MultiSelect = React.forwardRef<HTMLInputElement, MultiSelectProps>(
  (
    {
      name,
      validate,
      className,
      inputClassName,
      contentClassName,
      inlineValidation,
      label,
      required,
      disabled,
      items,
      getLabel = defaultMultiSelectGetLabel,
      validateWarning,
      mode = 'input',
      ...other
    },
    ref
  ) => {
    return (
      <FormItem
        name={name}
        inlineValidation={inlineValidation}
        className={className}
        label={label}
        required={required}
        disabled={disabled}
        validateWarning={validateWarning}
        contentClassName={contentClassName}
      >
        <Field name={name} validate={validate}>
          {({
            input: { value, onChange, onBlur, name, ...nother },
            meta,
          }: FieldRenderProps<any[]>) => {
            if (mode === 'input') {
              let titleArr: string[] = [];
              // let tooltipArr: any[] = [];
              items.forEach((i) => {
                if (value.indexOf(i.id) >= 0) {
                  titleArr.push(getLabel(i));
                  // tooltipArr.push(<ListItem>{getLabel(i)}</ListItem>);
                }
              });

              let info: React.ReactNode = '-';
              if (!value || value.length === 0) {
                info = (
                  <Text intent={'inactive'} italic>
                    Nevybráno
                  </Text>
                );
              } else if (value.length === 1) {
                info = titleArr[0];
              } else {
                info = `${titleArr[0]} (+${value.length - 1})`;
              }

              return (
                <FilterInputButton
                  {...DATA_FORM_INPUT(name)}
                  style={'link'}
                  tooltip={
                    meta.error ? undefined : titleArr.length > 0 ? (
                      titleArr.join(', ')
                    ) : (
                      <Text intent={'inactive'} italic>
                        Nevybráno
                      </Text>
                    )
                  }
                  className={Classes.FORM_MULTI_SELECT}
                  disabled={disabled || meta.submitting}
                  popupProps={{
                    mode: 'edit',
                    closeOnInnerClick: false,
                    arrow: true,
                    focusContentOnOpen: true,
                  }}
                  menu={(closePopup) => (
                    <MultiSelectSearch
                      title={label}
                      closePopup={closePopup}
                      className={classNames(
                        inputClassName,
                        Classes.FORM_MULTI_LIST
                      )}
                      value={value}
                      // @ts-ignore
                      ref={ref}
                      {...nother}
                      {...other}
                      onChange={(ids) => {
                        onChange({ target: { name, value: ids } });
                      }}
                      items={items}
                    />
                  )}
                >
                  {info}
                </FilterInputButton>
              );
            } else {
              return (
                <MultiSelectSearch
                  className={classNames(
                    inputClassName,
                    Classes.FORM_MULTI_LIST,
                    Classes.FORM_MULTI_LIST_INLINE
                  )}
                  disabled={disabled || meta.submitting}
                  noAutoFocus
                  hideCloseButton
                  value={value}
                  // @ts-ignore
                  ref={ref}
                  {...nother}
                  {...other}
                  onChange={(ids) => {
                    onChange({ target: { name, value: ids } });
                  }}
                  items={items}
                />
              );
            }
          }}
        </Field>
      </FormItem>
    );
  }
);
